import { render, staticRenderFns } from "./MiWeb.vue?vue&type=template&id=7d5c4ba2"
import script from "./MiWeb.vue?vue&type=script&lang=js"
export * from "./MiWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports